import { createAsyncThunk } from '@reduxjs/toolkit';
import { IThunkApi } from 'shared/types/redux';
import { initialState as defaultState } from '../../../slices/joinOtaIndividual';
import { fetchFormInitialData } from '../../../services/joinOtaIndividual/fetchFormInitialData';
import { IPublicV1ReceiptDetailsGetResponse } from 'shared/repositories/dailyrent/entities/response/PublicV1ReceiptDetailsGetResponse';

export const fetchInitialFormData = createAsyncThunk<IPublicV1ReceiptDetailsGetResponse, void, IThunkApi>(
  'joinOtaIndividual/fetchInitialFormData',
  async (_params, thunkApi) => {
    const { extra: context } = thunkApi;

    try {
      const { statusCode, response } = await fetchFormInitialData(context);

      if (statusCode === 200) {
        return response;
      }

      return defaultState;
    } catch (e) {
      return defaultState;
    }
  },
);
